import { Header } from '@tanstack/react-table';
import React from 'react';
import { Box } from '../../../../../Box/Box';
import { dataTableClassnames } from '../../../const/classNames';

interface CellResizerProps {
  header: Header<any, any>;
  tableBodyHeight?: number;
  disableResizeHandler?: boolean;
}

export const CellResizer: React.FC<CellResizerProps> = ({ header, tableBodyHeight, disableResizeHandler }) => {
  const resizeHandler = header.getResizeHandler();
  if (disableResizeHandler) {
    return null;
  }
  return (
    <Box
      sx={{
        '&:after': {
          bottom: -(tableBodyHeight ?? 0)
        }
      }}
      onMouseDown={resizeHandler}
      onTouchStart={resizeHandler}
      onDoubleClick={() => {
        header.column.resetSize();
      }}
      className={`${dataTableClassnames.table.cell.resizer.root} ${header.column.getIsResizing() ? dataTableClassnames.table.cell.resizer.state.resizing : ''}`}
    />
  );
};
